<template>
  <base-hm-input :id="id"
                 :class="$attrs['class']"
                 :label="label"
                 :help="help"
                 :has-focus="hasFocus"
                 :is-empty="isValueEmpty"
                 :name="name"
                 :cols="cols"
                 :hidden="hidden"
                 :disabled="disabledCombined"
                 @click="$emit('click', $event)">
    <textarea v-if="lazy"
              :id="`${id}-input`"
              v-model.trim.lazy="internalValue"
              :data-vv-as="label"
              :data-vv-name="name"
              :disabled="disabledCombined"
              :maxlength="length"
              :rows="inputRows"
              :class="['hm-input__textarea', { 'privacy--blur': privacyBlur}, {'hm-input__textarea--no-min-height': noMinHeight}]"
              type="text"
              @paste="onPaste"
              @keydown.enter="onEnter"
              @focus="onFocus"
              @blur="onBlur">
    </textarea>
    <textarea v-else
              :id="`${id}-input`"
              v-model.trim="internalValue"
              :data-vv-as="label"
              :data-vv-name="name"
              :disabled="disabledCombined"
              :maxlength="length"
              :rows="inputRows"
              :class="['hm-input__textarea', { 'privacy--blur': privacyBlur}, {'hm-input__textarea--no-min-height': noMinHeight}]"
              type="text"
              @paste="onPaste"
              @keydown.enter="onEnter"
              @focus="onFocus"
              @blur="onBlur">
    </textarea>
    <div v-if="length" class="hm-input__textarea__length">
      <span v-html="textLength"></span> / <span v-html="length"></span>
    </div>
  </base-hm-input>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import { isNil } from 'lodash';

export default {
  name: 'HmTextarea',

  mixins: [HmInputMixin],

  props: {
    length: {
      type: Number,
      required: false,
    },
    inputRows: {
      type: Number,
      default: 4,
      required: false,
    },
    lazy: {
      type: Boolean,
      default: true,
      required: false,
    },
    noMinHeight: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    textLength: function () {
      return this.internalValue.length;
    },
  },
  methods: {
    onEnter($event) {
      if (isNil($event)) {
        this.$emit('onenter');
      } else if (!$event.ctrlKey && !$event.shiftKey && !$event.metaKey) {
        // commented out, because it is not working as expected - despite this being required in the chatbot to quickly submit a message, it's hindering added new lines in the textarea in other place (like reservation comments)
        // $event.preventDefault();
        // $event.stopPropagation();
        this.$emit('onenter');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  textarea {
    min-height: 9.2rem;
  }

  .hm-input {
    &__textarea {
      &--no-min-height {
        min-height: 4.6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmTextarea.vue